var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTitle(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "20px",
    height: "16px",
    viewBox: "0 0 20 16",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "63FB75DB-89D5-40FB-858E-63FD7D2CD1FF") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Approved-Designs",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "location-existing-flow-3e",
    transform: "translate(-388.000000, -475.000000)",
    fill: "#9B9B9B",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-14",
    transform: "translate(368.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-40",
    transform: "translate(20.000000, 70.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-10",
    transform: "translate(0.000000, 256.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "input-box"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-33"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Group-31"
  }, /*#__PURE__*/React.createElement("g", {
    id: "business-card-of-a-man-with-contact-info",
    transform: "translate(0.000000, 1.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.348,9.1992 L8.8818,9.1992 C8.64,9.1992 8.4438,9.0036 8.4438,8.7618 C8.4438,8.6724 8.4798,8.586 8.544,8.5236 C8.8152,8.2602 9.0432,7.9056 9.2082,7.5234 C9.2418,7.548 9.2778,7.566 9.3186,7.566 C9.5802,7.566 9.8886,6.9876 9.8886,6.5934 C9.8886,6.1992 9.852,5.8794 9.5898,5.8794 C9.5586,5.8794 9.5262,5.8848 9.4926,5.8932 C9.474,4.824 9.204,3.4902 7.5714,3.4902 C5.868,3.4902 5.6694,4.8216 5.6502,5.8896 C5.6262,5.8848 5.6022,5.8794 5.58,5.8794 C5.3178,5.8794 5.2818,6.1992 5.2818,6.5934 C5.2818,6.9876 5.589,7.566 5.8512,7.566 C5.8836,7.566 5.9136,7.557 5.9418,7.5408 C6.1062,7.917 6.3312,8.2644 6.5982,8.5254 C6.6624,8.5878 6.6984,8.673 6.6984,8.763 C6.6984,9.0048 6.5022,9.201 6.2604,9.201 L5.7936,9.201 C4.7964,9.201 3.9882,10.0092 3.9882,11.0064 L3.9882,11.5068 C3.9882,11.8212 4.2432,12.0768 4.5582,12.0768 L10.5834,12.0768 C10.8978,12.0768 11.1528007,11.8212 11.1528007,11.5068 L11.1528007,11.0064 C11.1534,10.008 10.3452,9.1992 9.348,9.1992 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7534,4.2462 L9.7008,4.2462 C9.8466,4.569 9.951,4.9662 9.9942,5.4576 C10.1022,5.5242 10.1832,5.6316 10.2492,5.7612 L14.7534,5.7612 C14.9874,5.7612 15.1758,5.5722 15.1758,5.3388 L15.1758,4.6686 C15.1758,4.4358 14.9874,4.2462 14.7534,4.2462 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7534,7.0068 L10.3524,7.0068 C10.233,7.458 9.939,7.9302 9.5316,8.0562 C9.5196,8.0784 9.5058,8.0976 9.4932,8.1198 L9.4932,8.5218 L14.7528,8.5218 C14.9862,8.5218 15.1752028,8.3328 15.1752028,8.0988 L15.1752028,7.4292 C15.1758,7.1958 14.9874,7.0068 14.7534,7.0068 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.7534,9.7674 L11.3178,9.7674 C11.5446,10.1262 11.6778,10.5492 11.6778,11.0046 L11.6778,11.2824 L14.7534,11.2824 C14.9874,11.2824 15.1758,11.0934 15.1758,10.86 L15.1758,10.1898 C15.1758,9.9564 14.9874,9.7674 14.7534,9.7674 Z",
    id: "Path",
    stroke: "#FFFFFF",
    strokeWidth: 0.3
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.569,0.0342 L2.595,0.0342 C1.1616,0.0342 0,1.1958 0,2.6292 L0,12.9348 C0,14.3688 1.1616,15.5298 2.595,15.5298 L16.569,15.5298 C18.0024,15.5298 19.1634,14.3682 19.1634,12.9348 L19.1634,2.6292 C19.1634,1.1958 18.0024,0.0342 16.569,0.0342 Z M17.9388,12.9348 C17.9388,13.6902 17.3244,14.3046 16.569,14.3046 L2.595,14.3046 C1.8396,14.3046 1.2252,13.6902 1.2252,12.9348 L1.2252,2.6292 C1.2252,1.8738 1.8396,1.2594 2.595,1.2594 L16.569,1.2594 C17.3244,1.2594 17.9388,1.8738 17.9388,2.6292 L17.9388,12.9348 Z",
    id: "Shape"
  }))))))))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTitle);
export default __webpack_public_path__ + "static/media/title.e25ad14d076f63dbf6b23617126ae920.svg";
export { ForwardRef as ReactComponent };